import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import { Object3D } from '../core/Object3D.js';

var Group = /*#__PURE__*/function (_Object3D) {
  _inheritsLoose(Group, _Object3D);

  function Group() {
    var _this;

    _this = _Object3D.call(this) || this;
    _this.type = 'Group';
    return _this;
  }

  return Group;
}(Object3D);

Group.prototype.isGroup = true;
export { Group };